export type ShareReadingState =
  | 'available'
  | 'receiving'
  | 'sending-pending'
  | 'sending-active'
  | 'off'

export interface ShareReadingFlags {
  send_readings?: boolean
  receive_readings?: boolean
  partner_send_readings?: boolean
  partner_receive_readings?: boolean
}

export interface ShareReadingDerived {
  state: ShareReadingState
  mode: 'receive' | 'send'
  on: boolean
  label: string
}

export const deriveShareReadingState = (
  p: ShareReadingFlags,
): ShareReadingDerived => {
  // A partner sharing to me takes priority: I act on the inbound feed.
  if (p.partner_send_readings) {
    const on = !!p.receive_readings
    return {
      state: on ? 'receiving' : 'available',
      mode: 'receive',
      on,
      label: on ? 'Receiving' : 'Receive',
    }
  }
  // No one is sending to me -> I can offer to be the sender.
  const on = !!p.send_readings
  if (!on) return { state: 'off', mode: 'send', on: false, label: 'Send' }
  return {
    state: p.partner_receive_readings ? 'sending-active' : 'sending-pending',
    mode: 'send',
    on: true,
    label: 'Sending',
  }
}
